module.exports = __webpack_public_path__ + "img/esmeralda-hotel-5.2f67acf9.jpg";